
export const AppConfig = {
    WATERFEE_QUERY: 'queryWaterfee',
    WATERFEE_LIST: 'listWaterfee',
    ACCOUNT_LIST: 'listAccount',
    ACCOUNT_GET: 'getAccount',
    ACCOUNT_UNBIND: 'unbindAccount',
    ACCOUNT_BIND: 'bindAccount',
    ACCOUNT_UPDATE: 'updateAccount',
    OUTLETS_LIST: 'listOutlets',
    OUTLETS_GET: 'getOutlets',
    INVOICE_ACCOUNT_LIST: 'listInvoiceAccount',
    INVOICE_ACCOUNT_GET: 'getAccountInvoice',
    INVOICE_CREATE: 'createInvoice',
    GET_RESUBMIT_TOKEN: 'getResubmitToken',
    PAGE_LIST: 'listPage',
    PAGE_GET: 'getPage',
    MENU_GET: 'getMenu',
    PLACE_ORDER: 'pay/placeorder.json',
    GET_MERCHANT: 'getMerchant',
    LIST_META_TYPE: 'metatype/list',
    REPAIR_CREATE_INIT: 'initRepair',
    REPAIR_CREATE: 'createRepair',
    REPAIR_LIST: 'listRepair',
    COMPLAIN_CREATE_INIT: 'initComplain',
    COMPLAIN_CREATE: 'createComplain',
    COMPLAIN_LIST: 'listComplain',
}